<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                <v-icon color="error">mdi-stop</v-icon>
                <!-- {{ !formData.id ? $t('global.menu.backoffice.createBrand') :
                $t('global.menu.backoffice.editBrand', { country: formData.name }) }} -->
                CREATE MERCHANT DIALOG ONLY FOR DEV PURPOSES 
                <v-icon color="error">mdi-stop</v-icon>
            </h3>
        </template>

        <template #default>
            <v-form ref="form">

                <v-row class="shop-info-container">
                    <!-- Linke Spalte: Basisinformationen -->
                    <v-col cols="12">
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.username') }}</v-label>
                                <v-text-field variant="outlined" v-model="formData.username" density="compact" :hide-details="true"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.email') }}</v-label>
                                <v-text-field variant="outlined" v-model="formData.email" density="compact" :hide-details="true"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.password') }}</v-label>
                                <v-text-field variant="outlined" v-model="formData.password" density="compact" :hide-details="true"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-row justify="center" align="center">
                            <v-col>
                                <v-label class="mr-4">{{ $t('global.form.name') }}</v-label>
                                <v-text-field variant="outlined" v-model="formData.name" density="compact" :hide-details="true"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>

                    <!-- {{ formData }} -->
                </v-row>
            </v-form>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="() => save()">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "CreateBrandDialog",
    components: {
    },


    methods: {
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';

const { proxy } = getCurrentInstance()
const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const form = ref(null)
const props = defineProps({
    save: Function, // Define prop as a function
});


// watch(
//     () => formData.value?.nameTranslations?.DE, // Safe access using optional chaining
//     (newValue) => {
//         if (newValue !== undefined) {
//             formData.value.name = newValue; // Update name
//         }
//     },
//     { deep: true } // Optional: If translations can be updated dynamically
// );
// watch(formData, (newValue) => {
//     if (!newValue) {
//         formData.value = { nameTranslations: { DE: '', EN: '' } };
//     }
// });
// watch(dialogVisible, (newValue) => {
//     if (!newValue) {
//         formData.value = { nameTranslations: { DE: '', EN: '' } };
//     }
// });

const nameRules = [
    v => !!v || 'Name is required',
    v => (v && v.length >= 3) || 'Name must be at least 3 characters',
];
const validate = async () => {
    const { valid, errors } = await form.value.validate()
    if (!valid) {
        let errorMessages = [];
        Object.values(errors).forEach(fieldErrors => {
            if (fieldErrors.errorMessages.length) {
                errorMessages.push(...fieldErrors.errorMessages);
            }
        });
        errorMessages.forEach(msg => {
            if (msg.length) {
                proxy.$toast.error(msg, { theme: "colored" });
            }
        })
         
        return;
    }
    props.save();
}

const closeSheet = () => {
    dialogVisible.value = false;
    // formData.value = { nameTranslations: { DE: { value: '' }, EN: { value: '' } } };
}
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}
</style>
